import { differenceInDays, format, parseISO } from 'date-fns'
import { ANALYTICS_CATEGORY_FLIGHTS } from '@/constants/analytics'
import analytics from '@/shared-utils/analytics'

const handleClickOnPromoCard = (landingPageUrl: string) => {
  analytics.fireEvent({
    category: ANALYTICS_CATEGORY_FLIGHTS,
    action: 'price drop',
    label: 'click'
  })
  window.open(landingPageUrl, '_blank')
}

const calculateTripDuration = (departDate: string, returnDate: string) => {
  if (!departDate) return null
  if (!returnDate) return 'One Way'
  if (departDate === returnDate) return 'Same Day'

  const days = differenceInDays(new Date(returnDate), new Date(departDate))
  return `${days} ${days === 1 ? 'Day' : 'Days'}`
}

const formatDate = (date: string) => {
  if (!date) return null
  try {
    const parsedDate = parseISO(date)
    return format(parsedDate, 'MMM dd')
  } catch (error) {
    return null
  }
}

export { calculateTripDuration, formatDate, handleClickOnPromoCard }
